export const refreshPath = "<path d=\"M12.5 8 a4.5 4.5 0 1 1-1.3-3.2 M12.5 2.8 V5.2 H10.1\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>"
